import type { FileIconProps } from './FileIcon';

function FileDocumentIcon({ extension, color, size = 28, ...props }: FileIconProps) {
  return (
    <svg
      data-testid='icon-file'
      width={size}
      height={size * 1.25}
      viewBox='0 0 28 35'
      fill={color}
      {...props}>
      <path d='M4 35h20a4 4 0 004-4V10L18 0H4a4 4 0 00-4 4v27a4 4 0 004 4z' />
      <path opacity={0.4} d='M18 10V0l10 10H18z' fill='#fff' />
      <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
        {extension?.toUpperCase()}
      </text>
    </svg>
  );
}

export default FileDocumentIcon;
